import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import './navbar.css';
import logo from '../../images/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faShoppingCart, faExchangeAlt, faUsers, faClipboardList, faSignInAlt, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../context/AuthContext';
import LoginModal from '../Auth/LoginModal';

interface NavLink {
  label: string;
  href: string;
  icon: any;
  authOnly?: boolean;
}

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const location = useLocation();
  const { isLoggedIn, username, logout, sessionExpired } = useAuth();

  useEffect(() => {
    if (sessionExpired) {
      setShowLogin(true);
    }
  }, [sessionExpired]);

  const links: NavLink[] = [
    { label: 'בית', href: '/payments', icon: faHome },
    { label: 'קניות', href: '/purchases', icon: faShoppingCart },
    { label: 'העברות', href: '/transfers', icon: faExchangeAlt },
    { label: 'משתמשים', href: '/addOrRemoveUsers', icon: faUsers },
    { label: 'יומן', href: '/logs', icon: faClipboardList, authOnly: true },
  ];

  const visibleLinks = links.filter(link => !link.authOnly || isLoggedIn);

  return (
    <>
      <nav className="navbar">
        <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
          {visibleLinks.map((link, index) => (
            <li key={index}>
              <Link
                to={link.href}
                className={`nav-link ${location.pathname === link.href ? 'active' : ''}`}
                onClick={() => setIsOpen(false)}
              >
                <FontAwesomeIcon icon={link.icon} className="nav-icon" />
                <span>{link.label}</span>
              </Link>
            </li>
          ))}
        </ul>

        <div className="navbar-auth">
          {isLoggedIn ? (
            <button
              className="auth-btn auth-btn--logout"
              onClick={() => { logout(); setIsOpen(false); }}
              title={`יציאה (${username})`}
            >
              <FontAwesomeIcon icon={faSignOutAlt} className="nav-icon" />
              <span className="auth-btn__label">יציאה</span>
            </button>
          ) : (
            <button
              className="auth-btn auth-btn--login"
              onClick={() => { setShowLogin(true); setIsOpen(false); }}
            >
              <FontAwesomeIcon icon={faSignInAlt} className="nav-icon" />
              <span className="auth-btn__label">כניסה</span>
            </button>
          )}
        </div>

        <button
          className="hamburger"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="תפריט"
        >
          ☰
        </button>
        <div className="logo">
          <img className='image' src={logo} alt='logo' />
        </div>
      </nav>

      {showLogin && <LoginModal onClose={() => setShowLogin(false)} sessionExpired={sessionExpired} />}
    </>
  );
};

export default Navbar;
